import React, { useRef, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  VStack,
  Box,
  Button,
  Text,
  Input,
} from "@chakra-ui/react";

const ShareWithHCF = ({ isOpen, onClose, onReShareToHCF }) => {
  const fileInputRef = useRef(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [file, setFile] = useState(null);
  const handleUpload = (e) => {
    const file_data = e.target.files[0];
    setFile(e.target.files[0]);
    if (file_data && file_data.type === "application/pdf") {
      const objectUrl = URL.createObjectURL(file_data);
      setPdfUrl(objectUrl);
    } else {
      alert("Please upload a valid PDF file.");
    }
  };

  const triggerUpload = () => {
    fileInputRef.current.click();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color="primary.1" textAlign="center" fontSize="2xl">
          <Text>Share with HCF</Text>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <VStack spacing={4} align="stretch">
            <Input
              ref={fileInputRef}
              type="file"
              accept="application/pdf"
              onChange={handleUpload}
              display="none"
            />

            {/* Upload Button */}
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              {!pdfUrl && (
                <Button onClick={triggerUpload} colorScheme="blue" width="20%">
                  Upload PDF
                </Button>
              )}
            </Box>

            {/* After Upload: Show PDF + ReShare */}
            {pdfUrl && (
              <>
                <Box w="100%" h="70vh" position="relative" overflow="hidden">
                  <iframe
                    key={pdfUrl}
                    src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0`}
                    title="Uploaded PDF"
                    style={{ width: "100%", height: "100%", border: "none" }}
                  />
                </Box>
                <Box sx={{ display: "flex", justifyContent: "right" }}>
                  <Button
                    colorScheme="blue"
                    mt={4}
                    onClick={() => onReShareToHCF(file)}
                    width="20%"
                  >
                    Share to HCF
                  </Button>
                </Box>
              </>
            )}
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ShareWithHCF;

// import React from "react";
// import {
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalBody,
//   ModalCloseButton,
//   VStack,
//   Box,
//   Button,
//   Text,
// } from "@chakra-ui/react";

// const ShareWithHCF = ({ isOpen, onClose, vilReports, onReShareToHCF }) => {
//   return (
//     <Modal isOpen={isOpen} onClose={onClose} size="4xl" isCentered>
//       <ModalOverlay />
//       <ModalContent>
//         <ModalHeader color="primary.1" textAlign={"center"} fontSize={"2xl"}>
//           <Text>Share with HCF</Text>
//         </ModalHeader>
//         <ModalCloseButton />
//         <ModalBody pb={6}>
//           <VStack spacing={4} align="stretch">
//             {vilReports ? (
//               <>
//                 <Box w="100%" h="70vh" position="relative" overflow="hidden">
//                   <iframe
//                     src={`${vilReports}#toolbar=0&navpanes=0&scrollbar=0`}
//                     title={"VIL Report"}
//                     style={{
//                       width: "100%",
//                       height: "100%",
//                       border: "none",
//                     }}
//                   />
//                 </Box>
//                 <Button
//                   colorScheme="blue"
//                   mt={4}
//                   onClick={onReShareToHCF}
//                   width="full"
//                 >
//                   ReShare to HCF
//                 </Button>
//               </>
//             ) : (
//               <Text>No VIL reports available</Text>
//             )}
//           </VStack>
//         </ModalBody>
//       </ModalContent>
//     </Modal>
//   );
// };

// export default ShareWithHCF;
